import { useEffect } from "react";
import { setHeaderName } from "../../services/SetHeaderName";
import { Col, Divider, Row } from "antd";
import { Appointments } from "../Appointments/Appointments";
import { Complaints } from "../Admin/Complaints/Complaints";

export const HomePage = () => {
    useEffect(() => {
        if (location.pathname == '/Home') {
            setHeaderName("Home")
        }
    }, []);
    return (
        <div className="mx-2">
            <Row>
                {/* <Col span={24}>
                    <h5 className="">Appointments</h5>
                </Col> */}
                <Col span={24}>
                    <Appointments />
                </Col>
                <Divider />
                {/* <Col span={24}>
                    <h5 className="">complaints</h5>
                </Col> */}
                <Col span={24}>
                    <Complaints />
                </Col>
            </Row>
        </div >
    )
}